import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=3ca8d806&scoped=true"
import script from "./performance.vue?vue&type=script&lang=js"
export * from "./performance.vue?vue&type=script&lang=js"
import style0 from "./performance.vue?vue&type=style&index=0&id=3ca8d806&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca8d806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca8d806')) {
      api.createRecord('3ca8d806', component.options)
    } else {
      api.reload('3ca8d806', component.options)
    }
    module.hot.accept("./performance.vue?vue&type=template&id=3ca8d806&scoped=true", function () {
      api.rerender('3ca8d806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/performance.vue"
export default component.exports